<template>
  <div>
    <label>File Upload</label>
    <FilePond
      name="filepond"
      ref="pond"
      id="secure-file-upload"
      label-idle="Drop files here or <span class='filepond--label-action'>Browse</span>"
      allow-multiple="false"
      :server="filePondServer"
      :instantUpload="false"
      :files="file"
      credits="false"
      max-file-size="50MB"
    />

  </div>
</template>

<script>
import {v4 as uuidV4} from 'uuid';
import API from '@/api'

// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginValidateFileSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginValidateFileSize,
  FilePondPluginImagePreview
);

export default {
  name: "SecureFileUpload",
  components: {FilePond},
  data: () => ({
    file: null
  }),
  methods: {
    handleFilePondInit: function () {
      console.log("FilePond has initialized");
      // FilePond instance methods are available on `this.$refs.pond`
    },
    pondProcess(fieldName, file, metadata, load, error, progress, abort, transfer, options) {
      const Key = uuidV4();
      const request = new XMLHttpRequest();
      let abortedPreUpload = false;

      API.getS3PUTURL(Key, file.type)
        .then((response) => {
          if (abortedPreUpload) return;
          // fieldName is the name of the input field
          // file is the actual file object to send
          const formData = new FormData();
          Object.keys(response.fields).forEach(key => {
            formData.append(key, response.fields[key]);
          });
          // Actual file has to be appended last.
          formData.append("file", file);

          request.open('POST', response.url);

          // Should call the progress method to update the progress to 100% before calling load
          // Setting computable to false switches the loading indicator to infinite mode
          request.upload.onprogress = (e) => {
            progress(e.lengthComputable, e.loaded, e.total);
          };

          // Should call the load method when done and pass the returned server file id
          // this server file id is then used later on when reverting or restoring a file
          // so your server knows which file to return without exposing that info to the client
          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              const {name: filename, type: mimetype, size} = file;
              const {bucket} = response.fields;
              const {url} = response;

              API.createFile({
                filename,
                url: `${url}/${Key}`,
                mimetype,
                size,
                bucket,
                key: Key,
              })
              .then(({file}) => {
                console.log(file.id)
                // the load method accepts either a string (id) or an object
                load(file.id);
              })
              .catch(() => error('Could not save uploaded file'))
            } else {
              // Can call the error method if something is wrong, should exit after
              error('Could not upload file');
            }
          };

          request.send(formData);
        })
      .catch((e) => {
        console.error('Upload error', e)
        error('Could not upload file')
      })

      // Should expose an abort method so the request can be cancelled
      return {
        abort: () => {
          // This function is entered if the user has tapped the cancel button
          abortedPreUpload = true
          request.abort();

          // Let FilePond know the request has been cancelled
          abort();
        },
      };
    },
    pondRevert(uniqueFileId, load, error) {
      // Should remove the earlier created temp file here
      // ...

      // Can call the error method if something is wrong, should exit after
      // error(uniqueFileId);

      // Should call the load method when done, no parameters required
      // load();
    },
  },
  computed: {
    filePondServer() {
      return {
        process: this.pondProcess,
        revert: this.pondRevert
      }
    },
  }
}
</script>

<style lang="scss">
//.filepond--drop-label label {
//  color: red;
//  & span{
//    color:red;
//  }
//}

.filepond--file-action-button{
  color: #fff !important;
}

.filepond--file-action-button[disabled] {
  color: hsla(0, 0%, 100%, .5) !important;
}

.filepond--action-edit-item-alt {
  color: inherit !important;
}

.filepond--file {
  color: #fff !important;
}

.filepond--progress-indicator {
  color: #fff !important;
}

.filepond--root .filepond--credits {
  color: inherit !important;
}
</style>
